import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-district-grid',
  templateUrl: './district-grid.component.html',
  styleUrls: ['./district-grid.component.css']
})
export class DistrictGridComponent implements OnInit {

  title = "District List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/district/district-grid/district-grid.component.ts